var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.144 -0.000) scale(1.0206)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1095 13.455L16.6774 16.6329C15.6331 18.8981 15.111 20.0307 14.4315 20.3382C13.8422 20.6049 13.1604 20.5701 12.6013 20.2449C11.9567 19.8699 11.5525 18.69 10.7441 16.3304L7.83296 7.83296C7.17575 5.91462 6.84715 4.95545 7.069 4.30744C7.26212 3.74335 7.69683 3.29484 8.25461 3.0842C8.89538 2.84222 9.86434 3.14069 11.8023 3.73765L20.4833 6.41176C22.7801 7.11927 23.9285 7.47302 24.3237 8.09338C24.6666 8.63174 24.732 9.30144 24.4996 9.89591C24.2318 10.581 23.1735 11.1501 21.0568 12.2883L17.5 11.9763",
    stroke: "currentColor",
    strokeWidth: 1.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.dda8aa2f89e831741df0a741eeb12b91.svg";
export { ForwardRef as ReactComponent };